import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiListDataService} from './api.list-data.service';
import {AbstractModel} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ApiReportService extends ApiListDataService<AbstractModel, AbstractModel> {

  constructor(http: HttpClient) {
    super(http, '/Reports/AccessPro19_bonuses');
  }
}
